import React, { Component } from "react";
import ReactDOM from 'react-dom';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  InputGroup,
  InputGroupAddon,
  Input,
  Button,
  Modal,
  Container,
  Row
} from "reactstrap";
import axios from "axios";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPlane,
  faHotel,
  faCar,
  faHome,
  faMapSigns,
  faBuilding,
  faUtensils,
  faStore,
  faBars,
  faSearch
} from '@fortawesome/free-solid-svg-icons'
import { connect } from 'react-redux';
import { logIn, signUp, addAnn } from "../../../slices/modalSlice";
import { withRouter } from "react-router-dom";
import { get } from "request";
import SmallDiscussRow from "../../Admin/smallDiscussRow";
import AddAnnounceType from "../../Admin/addHebergement"
import AddVoyageAnnounce from "../../common/Voyages/addVoyage";
import AddVisaAnnounce from "../../common/Visas/AddVisaAnnounce";
import AddTransfertModal from "../../common/Cars/addTransfertModal";
import AddAnnounceCar from '../../Admin/addCar';








class NavBar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      link: { link: '' },
      isOpenSideBar: false,
      displayCarousel: "none",
      currentLink: window.location.href,
      searchInputTop: false,
      favs: [],
      profile: false,
      notif: false,
      msg: false,
      conversations: []
    }
    this.loginForm = this.loginForm.bind(this)
    this.signUpForm = this.signUpForm.bind(this)
    this.addAnnForm = this.addAnnForm.bind(this)

  };

  loginForm = () => this.props.dispatch(logIn())
  signUpForm = () => this.props.dispatch(signUp())
  addAnnForm = () => this.props.dispatch(addAnn())

  displaySearchInput = () => {
    this.setState({
      searchInputTop: !this.state.searchInputTop
    })
  }


  changeState(type) {
    const dropDown = this.state[type]
    this.setState({
      [type]: !dropDown,
    });
  }

  testLoginLink(isLogin) {
    if (isLogin) {
      this.setState({ link: { link: '/agent/' + isLogin._id } })
    }

  }
  toggle() {
    this.setState({ isOpenSideBar: !this.state.isOpenSideBar })
  }


  async componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
    // let favList = await httpClient.getFavorits(this.props.currentUser._id);
    // this.setState({
    //   favs : favList
    // })
    this.getConversations()
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);

    if (!domNode || !domNode.contains(event.target)) {
      this.setState({
        searchInputTop: false
      });
    }
    this.setState({
      profile: false,
      msg: false,
      notif: false
    })
  }



  getConversations = async () => {
    try {
      const host = process.env.REACT_APP_SERVER_URL
      const res = await axios.get(`${host}/api/conversations/user/` + this.user._id)
      console.log(res.data);
      this.setState({ conversations: res.data })

    } catch (error) {
      console.log(error);
    }
  }

  render() {
    const isLogin = this.props.currentUser
    const SearchInputMobileTop = this.state.searchInputTop
    const favs = []

    this.state.favs.forEach(elm => {
      favs.push(
        <li className="item_notif lightc">{elm.title}</li>
      )
    })

    const profile = this.state.profile
    const msg = this.state.msg
    const notif = this.state.notif
    const user = this.props.currentUser

    return (
      <>
        <div>

          <Navbar className="nv-mob py-0" expand='md' style={{ backgroundColor: '#39296a' }} fixed='top'>

            <Container style={{ paddingRight: "35px" }}>



              <NavbarToggler >
                <FontAwesomeIcon onClick={this.toggle.bind(this)} id="burger-mobile" icon={faBars} />
              </NavbarToggler>

              <Row >
                <Button className="loginButtonMob" onClick={this.loginForm} >
                  <span style={{ marginRight: "3px", fontSize: "12px" }}> S'inscrire </span>
                  <img src="/imgs/navebar/+.svg" alt="" id="plus-nav" />
                </Button>

                <Button className="loginButtonMob" onClick={this.loginForm}><span style={{ marginRight: "3px", fontSize: "12px" }}> Se Connecter</span>
                  <img src="/imgs/navebar/logIn.svg" id="logIn-rot" alt="" />
                </Button>
                <div className="pro-cirlce-navMob">
                  <span style={{ color: "white", top: "6px", position: "absolute", left: "2px", border: "white" }}>
                    PRO
                  </span>
                </div>

              </Row>



            </Container>
          </Navbar>



          <Navbar expand='md' style={{ height: "60px" }} className="bg-gh py-0" fixed='top'>
            <Container style={{ paddingRight: "35px" }}>
              <NavbarBrand href='/home' className="py-0">
                <img src="/imgs/logo/logo.svg" alt="logo" className="logo-navbar" />
              </NavbarBrand>

              <NavbarToggler >
                <FontAwesomeIcon onClick={this.toggle.bind(this)} id="burger-mobile" icon={faBars} />
              </NavbarToggler>

              <Modal isOpen={this.state.isOpenSideBar} toggle={this.toggle.bind(this)} style={{ backgroundColor: "#37296a" }} className="nav-bar-mobile-view">
                <div className="block-mobile-view-nav">
                  <div className="logo-mobile-view-side">
                    <img src="/imgs/logo/logo.svg" alt="logo" className="logo-mobile-side-nav" />
                  </div>
                  <input type="text" className="search-input-nav-mobile" placeholder=" Recherche" />
                  <div className="item-nav-mobile"><FontAwesomeIcon className="icon-mobile-nav" icon={faStore} /><span>Agences Touristique</span></div>
                  <div className="item-nav-mobile"><FontAwesomeIcon className="icon-mobile-nav" icon={faPlane} />Compagnes Aériennes</div>
                  <div className="item-nav-mobile"><FontAwesomeIcon className="icon-mobile-nav" icon={faHotel} />Hotels</div>
                  <div className="item-nav-mobile"><FontAwesomeIcon className="icon-mobile-nav" icon={faCar} /><a href="/cars">Location Voitures</a></div>
                  <div className="item-nav-mobile"><FontAwesomeIcon className="icon-mobile-nav" icon={faHome} />Maisons</div>
                  <div className="item-nav-mobile"><FontAwesomeIcon className="icon-mobile-nav" icon={faMapSigns} />Guides</div>
                  <div className="item-nav-mobile"><FontAwesomeIcon className="icon-mobile-nav" icon={faBuilding} />Agences de Divertissement</div>
                  <div className="item-nav-mobile"><FontAwesomeIcon className="icon-mobile-nav" icon={faUtensils} />Restaurants</div>

                </div>

              </Modal>
              <Collapse isOpen={this.state.isOpen} navbar >
                <Nav className='mr-auto' navbar>

                  <InputGroup className="search-parcour-desk searchInput_nav">
                    <InputGroupAddon addonType="prepend">
                    </InputGroupAddon>
                    <input className="search" placeholder="Trouver un établissment " />
                    <img src="/imgs/navebar/search_icn.svg" alt="" style={{ position: "absolute", color: "red", left: "8px", top: "5px" }} />
                  </InputGroup>


                  <UncontrolledDropdown nav inNavbar className="search-parcour-desk">
                    <DropdownToggle id="parcourir" className="drop-parcourir">
                      Parcourir
                      <img src="/imgs/navebar/downArrow.svg" alt="" class="arrowDown" />
                    </DropdownToggle>
                    <DropdownMenu left style={{ left: "10px" }}>


                      <NavLink href='/hebergement'>
                        <DropdownItem onMouseOver={() => document.getElementById("icnPr").firstChild.classList.add("wh-icon1")} onMouseLeave={() => document.getElementById("icnPr").firstChild.classList.remove("wh-icon1")}>
                          <svg className="prms-icon-nav" id="icnPr" xmlns="http://www.w3.org/2000/svg" width="31.495" height="23.69" viewBox="0 0 31.495 23.69">
                            <path className="icon-parcourir" id="Path_420" data-name="Path 420" d="M547.176,66.2,543.4,60.625a.876.876,0,0,0-.726-.385H520.911a.876.876,0,0,0-.726.385L516.411,66.2a1.959,1.959,0,0,0-.128,2.071,3.793,3.793,0,0,0,3.411,1.642h.34v13.14a.876.876,0,0,0,.876.876h21.765a.876.876,0,0,0,.876-.876V69.913h.34a3.793,3.793,0,0,0,3.412-1.642A1.959,1.959,0,0,0,547.176,66.2Zm-10.212-4.208,1.72,6.168H532.67V61.992Zm-10.5,0h4.452v6.168h-6.172Zm-8.634,5.458c-.037-.071-.059-.135.031-.268l3.514-5.19h3.27l-1.72,6.168H519.7A2.215,2.215,0,0,1,517.832,67.45Zm16.491,14.727V74.54h4.141v7.638Zm7.477,0h-1.583V73.663a.876.876,0,0,0-.876-.876h-5.894a.876.876,0,0,0-.876.876v8.514H521.788V69.913H541.8Zm3.956-14.727a2.216,2.216,0,0,1-1.863.711H540.5l-1.72-6.168h3.428l3.514,5.19C545.815,67.315,545.793,67.38,545.756,67.45Z" transform="translate(-516.047 -60.24)" fill="#37296a" />
                          </svg>
                          Agences Touristique
                        </DropdownItem>
                      </NavLink>

                      <NavLink href='/hebergement'>
                        <DropdownItem onMouseOver={() => document.getElementById("plane_icn").firstChild.classList.add("wh-icon1")} onMouseLeave={() => document.getElementById("plane_icn").firstChild.classList.remove("wh-icon1")}>
                          <svg className="prms-icon-nav" id="plane_icn" xmlns="http://www.w3.org/2000/svg" width="34.03" height="13.009" viewBox="0 0 34.03 13.009">
                            <path d="M999.091,1497.6a4.814,4.814,0,0,0-2.247-.464,18.736,18.736,0,0,0-5.477,1.134l-5.471,2.1-8.28-4.252a1.055,1.055,0,0,0-.854-.045l-.591.226a1,1,0,0,0-.618.671.97.97,0,0,0,.191.879l4.008,4.881-4.046,1.553c-1.2.46-2.153.026-4.521-.906-.77-.3-1.664-.657-2.728-1.047a1.043,1.043,0,0,0-.74.006l-1.083.416a1,1,0,0,0-.632.74.978.978,0,0,0,.309.916l2.757,2.5a1.039,1.039,0,0,0-.427,1.055c.194,1,1.321,1.047,3.146,1.047a49.05,49.05,0,0,0,8.388-.714l15.346-5.89c2.911-1.117,4.421-2.246,4.491-3.351A1.515,1.515,0,0,0,999.091,1497.6Zm-4.325,2.949-15.2,5.845a48.926,48.926,0,0,1-7.664.619.985.985,0,0,0-.309-.543l-1.524-1.384.345.137c2.863,1.126,4.254,1.6,6.046.912l5.337-2.049a1.006,1.006,0,0,0,.615-.671.974.974,0,0,0-.19-.879l-2.554-3.111,5.688,2.922a1.056,1.056,0,0,0,.856.045l5.9-2.263a16.886,16.886,0,0,1,4.733-1,4.313,4.313,0,0,1,.682.047A15.489,15.489,0,0,1,994.767,1500.545Z" transform="translate(-965.984 -1495.996)" fill="#37296a" />
                          </svg>
                          Compagnes Aériennes
                        </DropdownItem>
                      </NavLink>

                      <NavLink href='/hebergement'>
                        <DropdownItem onMouseOver={() => (document.getElementById("Group_119").firstChild.classList.add("wh-icon"))} onMouseLeave={() => document.getElementById("Group_119").firstChild.classList.remove("wh-icon")}>
                          <svg className="prms-icon-nav" id="Group_119" xmlns="http://www.w3.org/2000/svg" width="16" height="33.983" viewBox="0 0 24 33.983">
                            <g data-name="Group 119" transform="translate(-813.631 -120.48)">
                              <path id="Path_409" data-name="Path 409" d="M836.536,120.48h-21.81a1.063,1.063,0,0,0-1.095,1.029v31.926a1.063,1.063,0,0,0,1.095,1.029h21.81a1.063,1.063,0,0,0,1.095-1.029V121.509A1.063,1.063,0,0,0,836.536,120.48Zm-1.095,31.926H815.821V122.537h19.621Z" transform="translate(0 0)" fill="#37296a" />
                              <path id="Path_410" data-name="Path 410" d="M853.608,154.258a1.1,1.1,0,0,0,1.095-1.095v-3.284h5.1v3.284a1.095,1.095,0,1,0,2.19,0V144.4a1.095,1.095,0,1,0-2.19,0v3.284h-5.1V144.4a1.095,1.095,0,0,0-2.19,0v8.759A1.1,1.1,0,0,0,853.608,154.258Z" transform="translate(-31.787 -18.664)" fill="#37296a" />
                              <path id="Path_411" data-name="Path 411" d="M897.351,220.515v3.067a.73.73,0,0,0,.73.73h3.067a.73.73,0,0,0,.73-.73v-3.067a.73.73,0,0,0-.73-.73h-3.067A.73.73,0,0,0,897.351,220.515Zm1.46.73h1.607v1.607h-1.607Z" transform="translate(-68.443 -81.185)" fill="#37296a" />
                              <path id="Path_412" data-name="Path 412" d="M869.786,219.785h-3.067a.73.73,0,0,0-.73.73v3.067a.73.73,0,0,0,.73.73h3.067a.73.73,0,0,0,.73-.73v-3.067A.73.73,0,0,0,869.786,219.785Zm-.73,3.067h-1.608v-1.607h1.608Z" transform="translate(-42.804 -81.185)" fill="#37296a" />
                              <path id="Path_413" data-name="Path 413" d="M835.433,224.312H838.5a.73.73,0,0,0,.73-.73v-3.067a.73.73,0,0,0-.73-.73h-3.067a.73.73,0,0,0-.73.73v3.067A.73.73,0,0,0,835.433,224.312Zm.73-3.067h1.608v1.607h-1.608Z" transform="translate(-17.227 -81.185)" fill="#37296a" />
                              <path id="Path_414" data-name="Path 414" d="M901.148,249.9h-3.067a.73.73,0,0,0-.73.73V253.7a.73.73,0,0,0,.73.73h3.067a.73.73,0,0,0,.73-.73v-3.067A.73.73,0,0,0,901.148,249.9Zm-.73,3.067h-1.607v-1.607h1.607Z" transform="translate(-68.443 -105.809)" fill="#37296a" />
                              <path id="Path_415" data-name="Path 415" d="M869.786,249.9h-3.067a.73.73,0,0,0-.73.73V253.7a.73.73,0,0,0,.73.73h3.067a.73.73,0,0,0,.73-.73v-3.067A.73.73,0,0,0,869.786,249.9Zm-.73,3.067h-1.608v-1.607h1.608Z" transform="translate(-42.804 -105.809)" fill="#37296a" />
                              <path id="Path_416" data-name="Path 416" d="M835.433,254.432H838.5a.73.73,0,0,0,.73-.73v-3.067a.73.73,0,0,0-.73-.73h-3.067a.73.73,0,0,0-.73.73V253.7A.73.73,0,0,0,835.433,254.432Zm.73-3.067h1.608v1.607h-1.608Z" transform="translate(-17.227 -105.809)" fill="#37296a" />
                            </g>
                          </svg>
                          Hotels
                        </DropdownItem>
                      </NavLink>



                      <NavLink href='/cars'>
                        <DropdownItem onMouseOver={() => document.getElementById("Group_120").firstChild.classList.add("wh-icon")} onMouseLeave={() => document.getElementById("Group_120").firstChild.classList.remove("wh-icon")}>
                          <svg className="prms-icon-nav" id="Group_120" xmlns="http://www.w3.org/2000/svg" width="39.516" height="20" viewBox="0 0 39.516 20">
                            <g data-name="Group 120" transform="translate(-131.54 -423.131)">
                              <path id="Path_417" data-name="Path 417" d="M176.031,522.13a2.991,2.991,0,1,0,2.991,2.991A2.994,2.994,0,0,0,176.031,522.13Zm0,4.282a1.291,1.291,0,1,1,1.291-1.291A1.293,1.293,0,0,1,176.031,526.412Z" transform="translate(-35.623 -84.981)" fill="#37296a" />
                              <path id="Path_418" data-name="Path 418" d="M325.631,522.13a2.991,2.991,0,1,0,2.991,2.991A2.993,2.993,0,0,0,325.631,522.13Zm0,4.282a1.291,1.291,0,1,1,1.291-1.291A1.293,1.293,0,0,1,325.631,526.412Z" transform="translate(-164.039 -84.981)" fill="#37296a" />
                              <path id="Path_419" data-name="Path 419" d="M168.594,430.586a24.471,24.471,0,0,0-5.887-2.515c-.36-.112-.768-.24-.867-.288a26.852,26.852,0,0,1-3.307-2.06c-2.9-2.035-4.817-3.38-14.53-2.079-6.328.847-9.38,3.75-10.826,6.037a10.275,10.275,0,0,0-1.636,4.926.835.835,0,0,0,.007.121l.5,3.856a4.162,4.162,0,0,0,4.116,3.612.85.85,0,0,0,.817-1.082,3.557,3.557,0,1,1,6.845,0,.849.849,0,0,0,.817,1.082h12.7a.85.85,0,0,0,.817-1.082,3.557,3.557,0,1,1,6.845,0,.85.85,0,0,0,.817,1.082c2.25,0,4.127-1.622,4.9-4.232C171.448,435.542,171.084,432.2,168.594,430.586Zm.508,6.894a4.246,4.246,0,0,1-2.256,2.825q.007-.226-.005-.453a5.257,5.257,0,0,0-10.505.287q0,.178.012.355h-10.7a5.341,5.341,0,0,0,0-.642,5.257,5.257,0,0,0-10.505.287q0,.067,0,.134a2.458,2.458,0,0,1-1.416-1.912l-.5-3.784a8.876,8.876,0,0,1,1.418-4.064c1.831-2.837,5.05-4.582,9.568-5.186,9.055-1.212,10.663-.083,13.329,1.786a28.305,28.305,0,0,0,3.5,2.179,8.269,8.269,0,0,0,1.14.4,22.647,22.647,0,0,1,5.468,2.319C169.428,433.153,169.645,435.647,169.1,437.481Z" fill="#37296a" />
                            </g>
                          </svg>
                          Location Voiltures
                        </DropdownItem>
                      </NavLink>



                      <NavLink href='/hebergement/advanced_search'>
                        <DropdownItem onMouseOver={() => document.getElementById("plane_icnE").firstChild.classList.add("wh-icon1")} onMouseLeave={() => document.getElementById("plane_icnE").firstChild.classList.remove("wh-icon1")}>
                          <svg className="prms-icon-nav" id="plane_icnE" xmlns="http://www.w3.org/2000/svg" width="39.724" height="22.93" viewBox="0 0 39.724 22.93">
                            <path id="Path_421" data-name="Path 421" d="M584.7,337.57l-14.424-7.7a.971.971,0,0,0-.457-.114h-16.3a.969.969,0,0,0-.659.294h0l-.02.021-7.087,7.692a.972.972,0,1,0,1.429,1.317l.558-.605v9.054a.972.972,0,0,0,.707.935l14.783,4.185.015,0a.966.966,0,0,0,.1.021l.029,0a1,1,0,0,0,.121.008.968.968,0,0,0,.2-.021l15.389-3.239a.971.971,0,0,0,.772-.951V339.4h4.392a.972.972,0,0,0,.457-1.829Zm-35.023-1.2,4.042-4.387,8.8,5.517v12.934l-12.84-3.635Zm28.23,11.321-13.447,2.83v-11.8l.847.531a.972.972,0,0,0,.516.148h12.084Zm-11.8-10.236-9.173-5.752h12.645l10.782,5.752Z" transform="translate(-545.491 -329.76)" fill="#37296a" />
                          </svg>
                          Maisons
                        </DropdownItem>
                      </NavLink>



                      <NavLink href='/hebergement/advanced_search'>
                        <DropdownItem onMouseOver={() => document.getElementById("Group_127").firstChild.classList.add("wh-icon")} onMouseLeave={() => document.getElementById("Group_127").firstChild.classList.remove("wh-icon")}>
                          <svg className="prms-icon-nav" id="Group_127" xmlns="http://www.w3.org/2000/svg" width="32.797" height="26.5" viewBox="0 0 32.797 26.5">
                            <g data-name="Group 127" transform="translate(-964.498 -502.493)">
                              <path id="Path_422" data-name="Path 422" d="M1040.012,514.518a6.012,6.012,0,1,0-6.012-6.012A6.019,6.019,0,0,0,1040.012,514.518Zm0-9.658a3.645,3.645,0,1,1-3.645,3.646A3.649,3.649,0,0,1,1040.012,504.86Z" transform="translate(-55.792 0)" fill="#37296a" />
                              <path id="Path_423" data-name="Path 423" d="M1018.481,568.552a12.3,12.3,0,0,0-12.286,12.286,1.184,1.184,0,0,0,1.183,1.184h22.205a1.184,1.184,0,0,0,1.183-1.184A12.3,12.3,0,0,0,1018.481,568.552Zm-9.849,11.1a9.92,9.92,0,0,1,19.7,0Z" transform="translate(-33.472 -53.028)" fill="#37296a" />
                              <path id="Path_424" data-name="Path 424" d="M970.192,510.39a5.7,5.7,0,0,0-.725,0,5.2,5.2,0,0,0-4.223,2.626,5.455,5.455,0,0,0-.195,5.143l4.063,8.337a.8.8,0,0,0,1.433,0l4.063-8.337a5.454,5.454,0,0,0-.194-5.143A5.2,5.2,0,0,0,970.192,510.39Zm2.985,7.071-3.347,6.868-3.348-6.868a3.864,3.864,0,0,1,.14-3.643,3.631,3.631,0,0,1,2.946-1.838q.13-.008.262-.008c.088,0,.176,0,.262.008h0a3.631,3.631,0,0,1,2.945,1.838A3.864,3.864,0,0,1,973.177,517.461Z" transform="translate(0 -6.33)" fill="#37296a" />
                              <path id="Path_425" data-name="Path 425" d="M980.376,523.2a2.739,2.739,0,1,0,2.739,2.74A2.743,2.743,0,0,0,980.376,523.2Zm0,3.885a1.146,1.146,0,1,1,1.146-1.146A1.147,1.147,0,0,1,980.376,527.083Z" transform="translate(-10.547 -16.621)" fill="#37296a" />
                            </g>
                          </svg>
                          Guides</DropdownItem>
                      </NavLink>



                      <NavLink href='/hebergement/advanced_search'>
                        <DropdownItem onMouseOver={() => document.getElementById("Group_203").firstChild.classList.add("wh-icon1")} onMouseLeave={() => document.getElementById("Group_203").firstChild.classList.remove("wh-icon1")}>
                          <svg className="prms-icon-nav" id="Group_203" xmlns="http://www.w3.org/2000/svg" width="29.483" height="37" viewBox="0 0 29.483 37">
                            <path id="Path_432" data-name="Path 432" d="M1026.637,123.94a14.738,14.738,0,1,0-17.076,22.59l-1.92,6.853a1.294,1.294,0,0,0,1.246,1.643h12.778a1.294,1.294,0,0,0,1.229-1.7l-2.3-6.982a14.849,14.849,0,0,0,3.073-1.773,14.74,14.74,0,0,0,2.973-20.631Zm-2.206,16.286-6.9-6.2,9.176,1.322A12.042,12.042,0,0,1,1024.431,140.226Zm-21.623-9.19a12.319,12.319,0,0,1,.321-1.52l8.734,3.111-8.991,2.261A12.1,12.1,0,0,1,1002.808,131.036Zm11.018-1.066-5.539-7.437a12.046,12.046,0,0,1,5.06-1.829Zm3.949,2.351,8.37-4a12.038,12.038,0,0,1,.805,5.318Zm6.789-6.831a12.327,12.327,0,0,1,.835,1.279l-8.367,3.994,4.744-7.97A12.167,12.167,0,0,1,1024.564,125.491Zm-4.271-3.58-4.744,7.971-.478-9.261a12.374,12.374,0,0,1,1.5.122A12.176,12.176,0,0,1,1020.294,121.911Zm-13.389,1.655,5.537,7.435-8.737-3.112A12.043,12.043,0,0,1,1006.9,123.566Zm-3.61,12.995,8.989-2.261-6.219,6.867A12.224,12.224,0,0,1,1003.294,136.561Zm4.048,5.767,4.917-5.43-2,7.128A12.074,12.074,0,0,1,1007.342,142.328Zm7.514-5.1,2.457,7.445a12.163,12.163,0,0,1-4.211.126c-.118-.017-.233-.039-.35-.06Zm5.02,15.213h-9.281l1.456-5.2c.226.043.453.083.683.116a14.929,14.929,0,0,0,2.133.154,14.62,14.62,0,0,0,3.262-.37Zm-.1-8.566-2.582-7.826,6.083,5.462a12.092,12.092,0,0,1-3.5,2.364Z" transform="translate(-1000.094 -118.027)" fill="#37296a" />
                          </svg>
                          Agences de Divertissement
                        </DropdownItem>
                      </NavLink>



                      <NavLink href='/hebergement/advanced_search'>
                        <DropdownItem onMouseOver={() => document.getElementById("Group_200").firstChild.classList.add("wh-icon")} onMouseLeave={() => document.getElementById("Group_200").firstChild.classList.remove("wh-icon")}>
                          <svg className="prms-icon-nav" id="Group_200" xmlns="http://www.w3.org/2000/svg" width="34.504" height="29.835" viewBox="0 0 34.504 29.835">
                            <g id="Group_128" data-name="Group 128" transform="translate(-858.187 -386.495)">
                              <path id="Path_429" data-name="Path 429" d="M883.728,399.8a2.068,2.068,0,0,0,1.5-.574l7.294-7.3a.58.58,0,1,0-.821-.818l-7.294,7.294c-.426.424-1.509.281-2.5-.545-.1-.084-.2-.177-.3-.276a3.3,3.3,0,0,1-.27-.3h0a3.44,3.44,0,0,1-.731-1.4,1.215,1.215,0,0,1,.183-1.1l7.294-7.294a.581.581,0,0,0-.821-.821l-7.294,7.294a2.273,2.273,0,0,0-.5,2.182,4.474,4.474,0,0,0,.762,1.607l-6.082,6.082-4.736-4.736a5.124,5.124,0,0,0,.506-2.3,8.568,8.568,0,0,0-1.831-5.042c-2.347-3.1-6.066-4.265-8.292-2.582s-2.121,5.576.229,8.68a7.8,7.8,0,0,0,5.863,3.351,3.944,3.944,0,0,0,2.409-.76l4.62,4.62-9.645,9.645a.858.858,0,1,0,1.216,1.212l9.644-9.642,9.8,9.8a.87.87,0,0,0,1.232-1.229l-9.8-9.8,6.081-6.08A4.005,4.005,0,0,0,883.728,399.8Zm-15.757-1.392a2.2,2.2,0,0,1-.621.747l-.041.03-.018.013c-1.5,1.06-4.248,0-6-2.313a6.706,6.706,0,0,1-1.475-4.677,2.579,2.579,0,0,1,.936-1.766,2.388,2.388,0,0,1,1.473-.456,4.75,4.75,0,0,1,2.35.717,7.714,7.714,0,0,1,2.232,2.008c1.322,1.748,1.846,3.909,1.3,5.378A2.722,2.722,0,0,1,867.97,398.409Z" fill="#37296a" />
                              <path id="Path_430" data-name="Path 430" d="M949.982,403.39a.58.58,0,0,0,.821,0l5.37-5.37a.58.58,0,0,0-.82-.82l-5.37,5.37A.581.581,0,0,0,949.982,403.39Z" transform="translate(-65.043 -7.478)" fill="#37296a" />
                              <path id="Path_431" data-name="Path 431" d="M944.652,398.06a.581.581,0,0,0,.82,0l5.37-5.37a.58.58,0,1,0-.82-.82l-5.37,5.37A.58.58,0,0,0,944.652,398.06Z" transform="translate(-61.259 -3.694)" fill="#37296a" />
                            </g>
                          </svg>
                          Restaurants</DropdownItem>
                      </NavLink>

                    </DropdownMenu>
                  </UncontrolledDropdown>
                </Nav>
                {
                  !isLogin &&
                  <>
                    <Button className="signupButton my-2" onClick={this.loginForm} >
                      <span className="px-2 ">S'inscrire</span>
                      <img className="mb-2" src="/imgs/dashboard/account-plus.svg" alt="" />
                    </Button>

                    <Button className="loginButton" onClick={this.loginForm}>
                      <span className="px-2"> Se connecter</span>
                      <img className="mb-2" src="/imgs/dashboard/account-arrow-right.svg" alt="" />
                    </Button>

                    {/* <UncontrolledDropdown className="bg-gh">

                    <DropdownToggle style={{backgroundColor:"#182952",border:"0",padding:"0"}}>
                      
                  <div className="pro-cirlce-nav bg-gh">
                    <span style={{color:"white",top:"8px",position:"absolute",left:"3px",border:"white"}}>
                      PRO
                    </span>
                 </div>
                 </DropdownToggle>

                 <span className="" style={{color:"white",fontSize:"14px",marginLeft:"10px",}}>Fr</span>

                  <DropdownToggle style={{backgroundColor:"#182952",border:"0",padding:"0"}}>
                    <div className="flag">
                        <img className="flag-lang" src="/imgs/logo/france.png" alt="france"/>
                      </div>
                   </DropdownToggle>


                  <DropdownMenu className="menu-navbar-profile">
                    <DropdownItem>Arabic</DropdownItem>
                    <DropdownItem>English</DropdownItem>
                    <DropdownItem>Francais</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown> */}



                  </>
                }

                {isLogin &&
                  <div className="d-flex" style={{height: "60px"}}>
                    <AddAnnounceType idOwner={this.props.currentUser._id} />
                    <AddAnnounceCar />
                    <AddVoyageAnnounce idOwner={this.props.currentUser._id}/>
                    <AddVisaAnnounce/>
                    <AddTransfertModal />


                    {/* <NavLink id="dash-item" className="p-0 nav-item active" href={"/home"} >
                      <div className="px-3 py-2 d-flex flex-column align-items-center">
                        <img className="icon-nav" src="/imgs/home/HomeWhite.svg" alt="" />
                        <span className="dsh-item-text">Home</span>
                      </div>
                    </NavLink> */}

                    <NavLink id="dash-item" className="p-0 nav-item active" href={"/agent/" + isLogin._id} >
                      <div className="px-3 py-2 d-flex flex-column align-items-center">
                        <img className="icon-nav" src="/imgs/navebar/Dashboardw.svg" alt="" />
                        <span className="dsh-item-text">Dashboard</span>
                      </div>
                    </NavLink>

                    <div onClick={e => this.changeState("msg")}>
                      <UncontrolledDropdown inNavbar  >
                        <DropdownToggle className="navbar-toggle nav-item">
                          <div className="px-3 py-2 d-flex flex-column align-items-center justify-content-between" style={{ backgroundColor: msg && "white",height: "60px" }}>
                            {!msg && <img className="icon-nav" src="/imgs/navebar/Messagesw.svg" alt="" />}
                            {msg && <img className="icon-nav" src="/imgs/navebar/Messagesb.svg" alt="" />}
                            <span className="dsh-item-text" style={{ color: msg && "#37296a" }}>Messages</span>
                          </div>
                        </DropdownToggle>
                        <DropdownMenu className="menu-navbar-profile justify-menu-message">
                          <div className="arrow-nv"></div>
                          <div style={{ marginBottom: "10px", color: "#636060", fontSize: "18px" }}>
                            <center>Messages</center>
                          </div>
                          <hr style={{ width: "75%", marginBottom: "15px" }} />
                          <div className="conv__list mx-1">
                            {this.state.conversations.map((conv) => (
                              <SmallDiscussRow conversation={conv} currentUser={this.user} />
                            ))}

                          </div>
                          <div>
                            <NavLink href="/messagerie">
                              <div style={{ border: "1px solid rgba(0,0,0,.1)", borderRadius: "18px", padding: "7px", paddingLeft: "30px", paddingRight: "30px", textAlign: "center" }}>Afficher tous</div>
                            </NavLink>
                          </div>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </div>

                    <UncontrolledDropdown>
                      <DropdownToggle className="navbar-toggle" onClick={e => this.changeState("notif")} >
                        <div className="mx-2 py-2 d-flex flex-column align-items-center justify-content-between" style={{ backgroundColor: notif && "white",height: "60px" }}>
                          {!notif && <img className="icon-nav" src="/imgs/navebar/Notificationsw.svg" alt="" />}
                          {notif && <img className="icon-nav" src="/imgs/navebar/Notificationsb.svg" alt="" />}
                          <span className="dsh-item-text" style={{ color: notif && "#37296a" }}>Notifications</span>
                        </div>
                      </DropdownToggle>
                      <DropdownMenu className="menu-navbar-profile justify-menu-notif">
                        <div className="arrow-nv"></div>
                        <div style={{ marginBottom: "10px", color: "#636060", fontSize: "18px" }}>
                          <center>Notifications</center>
                        </div>
                        <hr style={{ width: "75%", marginBottom: "15px" }} />

                        <ul className="notif_list" style={{ fontFamily: "Gill Sans, sans-serif" }}>
                          <li className="item_notif"><div className="point-notif" style={{ backgroundColor: "green" }}></div> Vous aver recu un nouveau m...</li>
                          <li className="item_notif"><div className="point-notif" style={{ backgroundColor: "red" }}></div>Nouvelle notification</li>
                          <li className="item_notif inactive"><div className="point-notif" style={{ backgroundColor: "#ab9f9f" }}></div>notification déja vu</li>
                          <li className="item_notif"><div className="point-notif" style={{ backgroundColor: "red" }}></div>Vous aver recu un nouveau m...</li>
                          <li className="item_notif inactive"><div className="point-notif" style={{ backgroundColor: "#ab9f9f" }}></div>notification déja vu</li>
                          <li className="item_notif inactive"><div className="point-notif" style={{ backgroundColor: "#ab9f9f" }}></div>notification déja vu</li>
                        </ul>

                        <div>
                          <NavLink href="/agent/notifications">
                            <div style={{ border: "1px solid rgba(0,0,0,.1)", borderRadius: "18px", padding: "7px", paddingLeft: "30px", paddingRight: "30px", textAlign: "center" }}>Afficher tous</div>
                          </NavLink>
                        </div>
                      </DropdownMenu>
                    </UncontrolledDropdown>

                    <UncontrolledDropdown onClick={e => this.changeState("profile")}>
                      <DropdownToggle className="navbar-toggle" >
                        <div className="mx-2 py-2 d-flex flex-column align-items-center justify-content-between" style={{ backgroundColor: profile && "white" ,height: "60px"}} >
                          {!profile && <img className="icon-nav" src="/imgs/navebar/Mew.svg" alt="" />}
                          {profile && <img className="icon-nav" src="/imgs/navebar/Meb.svg" alt="" />}
                          <span className="dsh-item-text mx-3" style={{ color: profile && "#37296a" }}>Moi</span>
                        </div>
                      </DropdownToggle>
                      <DropdownMenu className="menu-navbar-profile justify-menu-profile">
                        <div className="container">
                          <div className="d-flex align-items-center">
                            <img src="/imgs/profilePic/profile.png" alt="" style={{ borderRadius: "50%", width: "60px" }} />
                            <div className="d-flex flex-column ml-2">
                              <h5 className="font-weight-bold">{user.name}</h5>
                              {/* <p>Agence de Voyage</p> */}
                            </div>
                          </div>

                          <div className="mt-4 d-flex justify-content-between" style={{ width: "100%" }}>
                            <div className="d-flex flex-column align-items-center">
                              <img src="/imgs/navebar/Favoris.svg" alt="favoris" style={{ width: "20px", height: "20px" }} />
                              <span className="sm-det">Favoris</span>
                            </div>
                            <div className="d-flex flex-column align-items-center">
                              <img src="/imgs/navebar/Abonnements.svg" alt="favoris" style={{ width: "20px", height: "20px" }} />
                              <span className="sm-det">Abonnements</span>
                            </div>
                            <div className="d-flex flex-column align-items-center">
                              <img src="/imgs/navebar/Portefeuille.svg" alt="favoris" style={{ width: "20px", height: "20px" }} />
                              <span className="sm-det">Portfeuille</span>
                            </div>
                            <div className="d-flex flex-column align-items-center">
                              <img src="/imgs/navebar/Coupons.svg" alt="favoris" style={{ width: "20px", height: "20px" }} />
                              <span className="sm-det">Coupons</span>
                            </div>
                          </div>

                          <h5 className="font-weight-bold mt-3">Mes Achats</h5>
                          <hr style={{ width: "100%", marginBottom: "10px" }} />
                          <div className="mt-1 d-flex justify-content-between" style={{ width: "100%" }}>
                            <div className="d-flex flex-column align-items-center">
                              <img src="/imgs/navebar/a_payer.svg" alt="favoris" style={{ width: "20px", height: "20px" }} />
                              <span className="sm-det">A Payer</span>
                            </div>
                            <div className="d-flex flex-column align-items-center">
                              <img src="/imgs/navebar/Payées.svg" alt="favoris" style={{ width: "20px", height: "20px" }} />
                              <span className="sm-det">Payées</span>
                            </div>
                            <div className="d-flex flex-column align-items-center">
                              <img src="/imgs/navebar/Confirmées.svg" alt="favoris" style={{ width: "20px", height: "20px" }} />
                              <span className="sm-det">Confirmées</span>
                            </div>
                            <div className="d-flex flex-column align-items-center">
                              <img src="/imgs/navebar/Toutes.svg" alt="favoris" style={{ width: "20px", height: "20px" }} />
                              <span className="sm-det">Toutes</span>
                            </div>
                          </div>

                          <h5 className="font-weight-bold mt-3">Mon Compte</h5>
                          <hr style={{ width: "100%", marginBottom: "10px" }} />
                          <div className="d-flex flex-column">
                            <div className="d-flex align-items-center">
                              <img className="mr-1" src="/imgs/navebar/Settings.svg" alt="settings" />
                              <span>Parametres</span>
                            </div>

                            <div className="d-flex flex-column">
                              <div className="d-flex align-items-center">
                                <img className="mr-1" src="/imgs/navebar/Settings.svg" alt="settings" />
                                <span>Aides</span>
                              </div>
                            </div>
                          </div>
                          <div className="col align-self-center mt-3">
                            <NavLink href='/logout' >
                              <div className="deconn-btn">Deconnexion</div>
                            </NavLink>
                          </div>

                        </div>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                    
                    <NavLink id="dash-item" className="p-0 nav-item active" href={"/panier"} >
                        <div className="mx-3 py-2 d-flex flex-column align-items-center justify-content-between" style={{height: "60px"}}>
                          <img className="icon-nav" src="/imgs/navebar/Cartw.svg" alt="" />
                          <span className="dsh-item-text">Panier</span>
                        </div>
                    </NavLink>

                    <button className="mx-1 border-left py-2 btn d-flex flex-column align-items-center justify-content-between" onClick={this.addAnnForm}>
                      <img className="icon-nav" src="/imgs/navebar/Addw.svg" alt="" />
                      <span className="dsh-item-text mb-3">Ajouter</span>
                    </button>

                  </div>
                  
                }
              </Collapse>
            </Container>
          </Navbar>
          <UncontrolledDropdown>
            <input type="text" style={{ backgroundColor: "white", outline: "unset", boxShadow: "0 6px 12px rgb(0 0 0 / 18%)", border: "none", position: "fixed", width: "100%", height: "50px", marginTop: (SearchInputMobileTop && "-36px") || (!SearchInputMobileTop && "-120px") }} placeholder=" Recherche..." />

          </UncontrolledDropdown>
        </div>

        <section style={{ marginTop: "7rem" }}></section>
      </>
    );
  }
}



//connect function INJECTS dispatch function as a prop!!

const mapDispatchToProps = dispatch => ({
  logIn,
  signUp,
  dispatch
})

export default withRouter(connect(null, mapDispatchToProps)(NavBar));